"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const App_1 = require("./components/App");
require("./index.scss");
// import '../../overrideStyle.scss'
const el = document.getElementById('app');
const params = new URLSearchParams(window.location.search);
function getSchoolId(url) {
    const urlObj = new URL(url);
    const segments = urlObj.pathname.split('/');
    return segments[segments.length - 1];
}
const schoolId = params.get('school') || getSchoolId(window.location.href);
const frame = params.get('frame');
const showHeading = params.get('showHeading');
const testMode = params.get('testMode') === 'true';
const showPerTerm = params.get('showPerTerm') === 'true';
const showFeeTable = params.get('showFeeTable') === 'true';
if (!schoolId) {
    throw new Error('School ID not found');
}
react_dom_1.default.render((0, jsx_runtime_1.jsx)(react_1.default.StrictMode, { children: (0, jsx_runtime_1.jsx)(App_1.App, { school: schoolId, frame: frame, showHeading: showHeading, testMode: testMode, showPerTerm: showPerTerm, showFeeTable: showFeeTable }) }), el);
